export const convertNumber = (str: string): string | void => {
	/* v-'Use literal notation when the regular expression will remain constant.' MDN */
	const re = /^\d+\s/;

	const arr: string[] | null = re.exec(str);
	if (arr !== null) {
		switch (arr[0]) {
			case '1 ':
				return str.replace(/^1+\s/, 'Ein ');
			case '2 ':
				return str.replace(/^2+\s/, 'Zwei ');
			case '3 ':
				return str.replace(/^3+\s/, 'Drei ');
			case '4 ':
				return str.replace(/^4+\s/, 'Vier ');
			case '5 ':
				return str.replace(/^5+\s/, 'Fünf ');
			case '6 ':
				return str.replace(/^6+\s/, 'Sechs ');
			case '7 ':
				return str.replace(/^7+\s/, 'Sieben ');
			case '8 ':
				return str.replace(/^8+\s/, 'Acht ');
			case '9 ':
				return str.replace(/^9+\s/, 'Neun ');
			case '10 ':
				return str.replace(/^10+\s/, 'Zehn ');
			default:
				console.error('Not a valid number');
		}
	} else {
		return str;
	}
};

export const joinDifferentSeparators = (
	array: string[],
	separator: string,
	lastSeparator: string
): string => {
	if (array.length === 1) {
		return array[0];
	}

	const others = array.slice(0, array.length - 1);
	return `${others.join(separator)} ${lastSeparator} ${array[array.length - 1]}`.trim();
};

export const joinFilters = (
	array: string[],
	separator: string,
	lastSeparator: string,
	max: number
): string => {
	if (array.length > 1) {
		const length = Math.min(max || array.length, array.length) - 1;

		if (array.length > max) {
			return `${array.slice(0, max).join(separator)} und ${array.length - max} ${
				array.length - max >= 2 ? 'weitere' : 'weiterer'
			} Filter`.trim();
		}

		const others = array.slice(0, length);
		return `${others.join(separator)} ${lastSeparator} ${array[length]}`.trim();
	}
	return array.join(lastSeparator).trim();
};

export const joinFields = (
	array: string[],
	separator: string,
	lastSeparator: string,
	max: number
): string => {
	if (array.length === 1) {
		return `im Bereich ${array[0]}.`;
	}

	if (array.length > 1) {
		const length = Math.min(max || array.length, array.length) - 1;

		if (array.length > max) {
			return `in ${array.slice(0, max).join(separator)} und ${array.length - max} weiteren
			${array.length - max >= 2 ? 'Bereichen' : 'Bereich'}`.trim();
		}

		const others = array.slice(0, length);
		return `in den Bereichen ${others.join(separator)} ${lastSeparator} ${array[length]}`.trim();
	}
	return array.join(lastSeparator).trim();
};

export const copyStringToClipboard = (str: string) => {
	const el = document.createElement('textarea');
	el.value = str;
	el.setAttribute('readonly', '');
	el.style.cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';

	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
};

export const timedReload = (timeout: number) => {
	setTimeout(() => window.location.reload(), timeout);
};

export const groupArrayByProperty = (arr: Array<any>, property: string | number): Object =>
	arr?.reduce((acc, obj) => {
		const key = obj[property];
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(obj);
		return acc;
	}, {});
